import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { TextLink } from "@itandi/itandi-bb-ui/TextLink";
import { FormRow } from "~/components/common/deals/new/block/FormRow";
import type { Deal } from "~/models/Deal";
import {
	editRentRoomBuildingUrl,
	editRentRoomUrl
} from "~/utils/BukkenKanriPath";
import Styles from "../../../../../../common/deals/new/block/RoomBlockPropertySelectV2.module.scss";

type Props = {
	deal: Deal;
};

export const RoomBlockProperty: React.FC<Props> = ({ deal }) => {
	const selectedBuildingPropertyId = deal.isRegisterAsBuilding
		? deal.propertyId
		: deal.buildingPropertyId;
	const selectedRoomPropertyId = deal.isRegisterAsBuilding
		? null
		: deal.propertyId;

	return (
		<>
			<FormRow label="物件名">
				<Flex alignItems="center" direction="row" gap=".5rem">
					<div>{deal.name}</div>
					{selectedBuildingPropertyId ? (
						<div className={Styles.ProductLinkContainer}>
							<TextLink
								color="link"
								href={editRentRoomBuildingUrl(selectedBuildingPropertyId)}
								target="_blank"
							>
								物件システム
							</TextLink>
						</div>
					) : null}
				</Flex>
			</FormRow>
			<FormRow label="部屋番号">
				<Flex alignItems="center" direction="row" gap=".5rem">
					<div>
						{deal.isRegisterAsBuilding
							? "棟または戸建てとして登録"
							: deal.roomNumber}
					</div>
					{selectedRoomPropertyId ? (
						<div className={Styles.ProductLinkContainer}>
							<TextLink
								color="link"
								href={editRentRoomUrl(selectedRoomPropertyId)}
								target="_blank"
							>
								物件システム
							</TextLink>
						</div>
					) : null}
				</Flex>
			</FormRow>

			<FormRow label="物件住所">{deal.address}</FormRow>
		</>
	);
};
